module.exports = __webpack_public_path__ + "static/media/Dev3.3935f571.png";